import React from 'react';
import { Box, Link, Icon } from '@amzn/awsui-components-core';
import { DateTime } from 'luxon';

import { maxCardSummaryLength, trimString } from '../../../api/UtilsApi';
import { COLLECTION_VIEWER_PREFIX } from '../../../common/RouterPaths';
import { CollectionWithTemplateMetaData } from './CommunityCollection';
import CollectionCardLikeDislike from './CollectionCardLikeDislike';

const filledHeartSvgPath = '/images/heart-filled.svg';

interface Props {
  collection: CollectionWithTemplateMetaData;
}

const CollectionCardView = ({ collection }: Props) => {
  const { title, description, createdAt, isOfficial, like = 0, dislike = 0 } = collection;

  const renderOfficialBadge = () => {
    if (!isOfficial) {
      return null;
    }
    return (
      <Box margin={{ top: 's' }}>
        <div className="community-collection-official-offering">Official offering</div>
      </Box>
    );
  };

  const renderFavIcon = () => {
    const { hasRated } = collection;
    if (hasRated) {
      return (
        <Box variant="span" float="right">
          <Icon url={filledHeartSvgPath} alt="Favorited" />
        </Box>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="community-collection-card-container">
      <div className="community-collection-card-body overflow-wrap-break-word">
        <span className="community-collection-card-type">Collection {renderFavIcon()}</span>
        <div className="community-collection-card-title">
          <Link href={`${COLLECTION_VIEWER_PREFIX}/${collection.collectionId}`} variant="primary">
            {title}
          </Link>
        </div>
        <Box color="text-body-secondary" fontSize="body-s">
          {trimString(description, maxCardSummaryLength)}
        </Box>
        {renderOfficialBadge()}
      </div>
      <div className="community-collection-card-bottom">
        {createdAt.toLocaleString(DateTime.DATE_FULL)}
        <Box display="inline-block" padding={{ left: 'xs' }} float="right">
          <CollectionCardLikeDislike like={like} dislike={dislike} />
        </Box>
      </div>
    </div>
  );
};

export default CollectionCardView;
